import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  supportDataOrEmptyObjectSelector,
  graphDataOrEmptyObjectSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../FinancialAccountsWorkflowConstants';
import { OVERVIEW } from './AccountsManualStepViews';

export const viewIdSelector = createSelector(
  supportDataOrEmptyObjectSelector,
  supportData => get(supportData, `${BACKEND_KEY}.accountViewId`, OVERVIEW),
);

export const previousViewIdSelector = createSelector(
  supportDataOrEmptyObjectSelector,
  supportData => get(supportData, `${BACKEND_KEY}.previousViewId`, null),
);

export const accountsSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphData => get(graphData, `${BACKEND_KEY}`, OVERVIEW),
);

export const visibleAccountsSelector = createSelector(
  accountsSelector,
  accounts => accounts.filter(({ IsDeleted }) => !IsDeleted),
);
